import {
  colors,
  getBorderRadius,
  getHeight,
  getSpacing,
} from '@cabonline/ui-shared';
import styled from '@emotion/styled';

import { ButtonProps } from '../button';
import { Pill } from '../pill';
import { HeaderSize, HeaderStyle } from './types';

interface StyledContainerProps {
  isExpanded?: boolean;
  testID?: string;
}

export const StyledContainer = styled.div<StyledContainerProps>`
  border: ${(props) =>
    props.isExpanded
      ? `2px solid ${colors.black}`
      : `1px solid ${colors.gray2}`};
  margin: ${(props) => (props.isExpanded ? 'none' : '1px')};
  border-radius: ${getBorderRadius('s')};
  margin-bottom: ${getSpacing('s')};
`;

export const StyledHeaderContainer = styled.div<{
  headerSize: HeaderSize;
  hasError?: boolean;
}>`
  display: flex;
  align-items: stretch;
  min-height: ${(props) => (props.hasError ? '76px' : getHeight('m'))};
  ${(props) =>
    props.headerSize === 'large' &&
    `
      min-height: ${props.hasError ? getHeight('l') : '60px'};
    `}
`;

interface HeaderProps {
  isExpanded: boolean;
  headerStyle?: HeaderStyle;
  headerSize?: HeaderSize;
  clickable?: boolean;
}

export const StyledHeader = styled.button<HeaderProps & ButtonProps>`
  padding: 0 ${getSpacing('xxs')};
  text-align: left;
  flex: 1;
  min-width: 0;
  cursor: ${(p) => (p.clickable ? 'pointer' : 'default')};
  border: none;
  border-radius: ${(props) =>
    props.isExpanded ? 'none' : getBorderRadius('s')};

  ${(props) =>
    props.headerStyle === 'default' &&
    `
      background-color: ${props.isExpanded ? colors.black : colors.white};
      &:focus {
        border: ${
          props.isExpanded && props.clickable
            ? `2px solid ${colors.white}`
            : 'none'
        };
        outline: ${props.clickable ? `2px solid  ${colors.black}` : `none`};
      }
    `}

  ${(props) =>
    props.headerStyle === 'outline' &&
    `
      background-color: transparent;
      &:focus {
        outline: 2px solid  ${colors.black};
      }
    `}
`;

export const StyledHeaderRow = styled.div<{ marginBottom?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${getSpacing('xxs')};
  ${(props) => props.marginBottom && `margin-bottom: ${getSpacing('xxs')}`}
`;

interface BodyProps {
  isExpanded: boolean;
  headerStyle?: HeaderStyle;
}

export const StyledBody = styled.div<BodyProps>`
  padding: ${getSpacing('s')};
  border-top: ${(props) =>
    props.isExpanded && props.headerStyle === 'outline'
      ? `2px solid ${colors.black}`
      : 'none'};
`;

export const StyledInnerWrap = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${getSpacing('m')};
`;

export const StyledInnerItem = styled.div`
  flex: 1;
`;

export const StyledActionWrapper = styled.div`
  margin-bottom: ${getSpacing('s')};
`;

export const StyledStatusPill = styled(Pill)`
  width: auto;
  color: ${(props) =>
    props.backgroundColor === colors.offWhite ||
    props.backgroundColor === colors.primary ||
    props.backgroundColor === colors.yellow
      ? colors.black
      : colors.white};
`;

export const StyledStatusPillWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${getSpacing('xxs')};
  margin-left: auto;
`;
export const StyledInnerItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledHeaderActions = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding-right: ${getSpacing('xxs')};
`;

// Re-export types for backward compatibility
export type { HeaderStyle, HeaderSize } from './types';
